module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1110.07d5bdda.png";